import styled from 'styled-components';

const Container = styled.h3`
  text-align: center;
`;

export default Container;
